import { defineNuxtPlugin } from 'nuxt/app';
import { useScreenSize } from '../composables/useScreenSize';

export default defineNuxtPlugin((nuxtApp) => {
	const screenSize = useScreenSize();
	nuxtApp.provide('screen', screenSize);
});
